import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, FUNCIONALIDADES } from '../../../../../routes';
import { getReeducandoDocumentosAnexos, cadastrarDocumentoAnexo, alterarDocumentoAnexo, excluirDocumentoAnexo, getTiposDocumentos, getReeducandoDocumentoAnexoVisualizacaoURL, baixarDocumentoAnexo, } from './services';
import { DocumentosAnexosBaseForm } from '../../../../../components/DocumentosAnexosBaseForm';
export var ReeducandosDocumentosAnexos = function (props) {
    var setAbaAtiva = props.setAbaAtiva;
    var services = {
        getTipos: getTiposDocumentos,
        getItens: getReeducandoDocumentosAnexos,
        cadastrarItem: cadastrarDocumentoAnexo,
        alterarItem: alterarDocumentoAnexo,
        excluirItem: excluirDocumentoAnexo,
        getVisualizacaoURL: getReeducandoDocumentoAnexoVisualizacaoURL,
        baixarItem: baixarDocumentoAnexo,
    };
    return (_jsx(DocumentosAnexosBaseForm, { pagina: FUNCIONALIDADES.REEDUCANDOS_DOCUMENTOS_ANEXOS, rotaVoltar: ROUTES.REEDUCANDOS, services: services, tipoIdField: 'tipo_documento_id', listaDocumentosField: 'documentos_anexos', titulo: 'Documento', abaVoltar: 2, setAbaAtiva: setAbaAtiva }));
};
export default ReeducandosDocumentosAnexos;
